// extracted by mini-css-extract-plugin
export var button = "_jy-2";
export var card = "_jy-0";
export var closeButtonContainer = "_jy-3";
export var iconContainer = "_jy-1";